module.exports = __webpack_public_path__ + "static/media/slate.a2639ac8.svg";